<!-- --------------------------------------- TOP NAV --------------------------------------- -->
<div class="top-nav">
  <ul class="flex-col-center gap-10">
    @for (item of mainLinks(); track item.id; let idx = $index) {
      @if (item.isShown && item.direction === "TOP") {
        <ng-container [ngTemplateOutlet]="iconItem" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      }
    }
  </ul>
</div>

<!-- --------------------------------------- BOTTOM NAV --------------------------------------- -->
<div class="bottom-nav">
  <ul class="flex-col-center gap-10">
    @for (item of mainLinks(); track item.id) {
      @if (item.isShown && item.direction === "BTN") {
        <ng-container [ngTemplateOutlet]="iconItem" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      }
    }
  </ul>
</div>

<ng-template #iconItem let-item>
  <a [routerLink]="item.routerLink ? item.routerLink : null">
    <li
      [pTooltip]="item?.tooltip ?? '' | translate"
      tooltipStyleClass="sxw-tooltip"
      (click)="selectItem(item)"
      [class.active]="item.isActive || arla.isActive"
      [class.expanded-item]="item.expanded && !item.isActive"
      #arla="routerLinkActive"
      [routerLinkActive]="item.routerLink ? 'active' : ''"
      [routerLinkActiveOptions]="{
        exact: item.routerLinkExact ?? false,
      }">
      @if (item.icon) {
        <sxw-svg-icon
          [class]="'icons'"
          width="15"
          height="15"
          [name]="item.icon"
          [fillColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"
          [strokeColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"></sxw-svg-icon>
      }
    </li>
  </a>
</ng-template>
